<template>
    <small>
        Gastos de gestión no incluidos -
        <span v-if="gastosOnline.interno">
            (Online: 0€ / {{ formatPrice(importe) }}) -
        </span>
        <span v-else>
            (Online: {{ gastosOnline.cantidad }}€ / {{ formatPrice(importe + gastosOnline.cantidad) }}) -
        </span>

        <span v-if="gastosTaquilla.interno">
            (Taquilla: 0€ / {{ formatPrice(importe) }}) -
        </span>
        <span v-else>
            (Taquilla: {{ gastosTaquilla.cantidad }}€ / {{ formatPrice(importe + gastosTaquilla.cantidad) }})
        </span>
    </small>
</template>

<script setup>
    import { computed } from 'vue'

    const props = defineProps({
        gdOnline: { type: Object, default: () => ({ cantidad: 0, modalidad: false, interno: false }) },
        gdTaquilla: { type: Object, default: () => ({ cantidad: 0, modalidad: false, interno: false }) },
        importe: { type: [Number, String], default: 0 }
    })

    function calcularGastos(gd, importe) {
        let cantidad = Number(gd.cantidad) || 0
        const precio = Number(importe) || 0

        if (gd.modalidad) {
            cantidad = (cantidad / 100) * precio
        }

        return {
            cantidad: redondear(cantidad, 2),
            interno: Boolean(gd.interno)
        }
    }

    const gastosOnline = computed(() => calcularGastos(props.gdOnline, props.importe))
    const gastosTaquilla = computed(() => calcularGastos(props.gdTaquilla, props.importe))

    function redondear(num, decimales = 2) {
        const signo = num >= 0 ? 1 : -1
        num = Math.abs(num)
        if (decimales === 0) return signo * Math.round(num)

        const factor = Math.pow(10, decimales)
        return signo * Math.round(num * factor) / factor
    }

    function formatPrice(value) {
        const number = Number(value)
        if (!Number.isFinite(number)) return '0,00€'
        return number.toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + '€'
    }
</script>
